import FormField from '@sportnet/ui/FormField/redux-form';
import * as React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { renderSectionTreeOptionLabel } from '../../../../../components/SectionSelect/index';
import { filterSectionTreeOptions } from '../../../../../components/SectionSelect/utils';
import { RootState } from '../../../../../rootReducer';
import { __ } from '../../../../../utilities';
import { sectionTreeOptionsSelector } from '../../../selectors';
import { usedColorsSelector } from '../../selectors';
import { socialOptions } from '../constants';

interface IOwnProps {}

const mapStateToProps = (state: RootState) => {
  return {
    sectionTreeOptions: sectionTreeOptionsSelector(state),
    usedColors: usedColorsSelector(state),
  };
};

type IProps = IOwnProps & ReturnType<typeof mapStateToProps>;

const FooterSimpleFields: React.FC<IProps> = ({
  usedColors,
  sectionTreeOptions,
}) => {
  return (
    <>
      <Field
        component={FormField}
        name="settings.footer.config.sectionIdOrUniqId"
        type="theselectsimple"
        label={__('Koreňová sekcia pre menu')}
        options={sectionTreeOptions}
        filterOptions={filterSectionTreeOptions}
        renderLabel={renderSectionTreeOptionLabel}
      />
      <Field
        component={FormField}
        name="settings.footer.config.textColorNav"
        type="colorInput"
        label={__('Farba textu navigácie')}
        propagateChangesImmediately
        colors={usedColors}
      />
      <Field
        component={FormField}
        name="settings.footer.config.backgroundColorNav"
        type="colorInput"
        label={__('Farba pozadia navigácie')}
        propagateChangesImmediately
        colors={usedColors}
      />
      <Field
        component={FormField}
        name="settings.footer.config.textColor"
        type="colorInput"
        label={__('Farba textu')}
        propagateChangesImmediately
        colors={usedColors}
      />
      <Field
        component={FormField}
        name="settings.footer.config.backgroundColor"
        type="colorInput"
        label={__('Farba pozadia')}
        propagateChangesImmediately
        colors={usedColors}
      />
      <Field
        component={FormField}
        name="settings.footer.config.borderColor"
        type="colorInput"
        label={__('Farba orámovania')}
        propagateChangesImmediately
        colors={usedColors}
      />
      <Field
        component={FormField}
        name="settings.footer.config.textContent1"
        label={__('Text 1')}
      />
      <Field
        component={FormField}
        name="settings.footer.config.textContent2"
        label={__('Text 2')}
      />
      <Field
        component={FormField}
        name="settings.footer.config.social"
        type="theselectsimple"
        label={__('Sociálne siete')}
        options={socialOptions}
        format={(value = '') => value || 'x'}
        parse={(value: string) => (value === 'x' ? '' : value)}
        clearable={false}
      />
    </>
  );
};

export default connect(mapStateToProps)(FooterSimpleFields);
